import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { TypeService } from '../../../../services/type/type-service';
import { UpdateContactInfoRequest } from '../../../../models/users/requests/submissionRequests/update-contact-info-request';
import { AbstractSubmissionFormViewModel } from '../submission-forms/abstract-submission-form/abstract-submission-form-view-model';

@Injectable()
export class UpdateContactInfoSubmissionFormViewModel extends AbstractSubmissionFormViewModel<UpdateContactInfoRequest> {
  constructor(router: Router, ngbModal: NgbModal) {
    super(router, ngbModal);
  }

  private typeService = inject(TypeService);

  public countryCodes$ = this.typeService.countryCodes$;

  protected createSubmissionMethod = (req: UpdateContactInfoRequest) =>
    this.submissionsDomainModel.createUpdateContactInfoSubmission(req);

  protected successMessage = $localize`Update Contact Information Request Submitted`;
}
